import ERC20 from "../abi/ERC20.json";
import { getAddress } from "./get-address";
import { ethers, BigNumber } from "ethers";

export const customApprove = async (_token, _amount) => {
    try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const { chainId } = await provider.getNetwork();
        const addresses = getAddress(chainId);

        if (addresses) {

            const signer = provider.getSigner();
            const tokenContract = new ethers.Contract(_token, ERC20.abi, signer);
            const decimals = await tokenContract.decimals()

            const formattedNum = parseInt(_amount);
            const bigNum = BigNumber.from(formattedNum.toString()).mul(BigNumber.from(10).pow(decimals));
            const GAS = "5";

            let gasPrice = await provider.getGasPrice();
            const convertGas = ethers.utils.parseUnits(GAS, "gwei");
            gasPrice.add(convertGas);

            const txn = await tokenContract.approve(addresses.dumpster_submission, bigNum, { gasPrice: gasPrice })

            const receipt = await provider.waitForTransaction(txn.hash, 1, 60000);

            if (receipt && receipt.status === 1) {

                await new Promise((resolve) => setTimeout(resolve, 8000));

                return { success: true, message: "Transaction successful", hash: txn.hash };
            } else {

                return { success: false, message: "Transaction failed", hash: txn.hash };
            }
        } else {
            return { success: false, message: "Wrong Network!" };
        }
    } catch (e) {
        // Check for user rejection error in MetaMask
        if (e.code === 4001) {
            return { success: false, message: "Transaction rejected by user." };
        }

        // Handle gas estimation errors
        if (e.code === "UNPREDICTABLE_GAS_LIMIT") {
            return { success: false, message: "Gas estimation failed. Try again later." };
        }

        // For other errors, return a simplified message
        return { success: false, message: `Error: ${e.message.split("(")[0]}` }; // Keep only the main error message

    }
}
